import React from 'react'
import axios from 'axios';
import {useContext, useEffect, useState} from 'react';
import CredsContext from "../../context/CredsContext";
import Recepisse from '../../components/RecepisseDepot/index'
import {useNavigate, useLocation} from "react-router-dom";
import Alert, { Alert2 } from '../../components/Alerte';
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import {Form,Button,Spinner,} from 'react-bootstrap';
import AlerteMessage from '../../components/AlerteMessage';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Env from '../../hooks/Env';
import Error from '../../components/Error';


const Admission = () => {
    useDocumentTitle('Admission');
    const handleClose3 = () => {
        setOpen(false)
    }
    const {creds, setCreds} = useContext(CredsContext);
    const { search } = useLocation();
    const navigate = useNavigate();
    useEffect (() => {
        const match = search.match(/email=(.*)/);
        const email = match?.[1];
        if (!email) {
            navigate("/pay");
        } else {
            axios({
            url:`${Env().API_URL}/paiement/confirmed/admission/${email}/${Env().ANNEE_UNIVERSITE}`,
            method: 'GET',
        })
        .then(result => {
            if (result?.data?.detail || result.data.amount !=='10125') {
                console.log("impossile de retrouver le paiment");
                navigate("/pay");
            } else {
                 console.log('donnes : ', result?.data);
                 setCreds({
                     ...creds,
                     email: result?.data?.email,
                     num_transaction: result?.data?.num_transaction
                 })
                //  console.log(creds)
            }
        })
        .catch((error) => {
            console.log('Error:', error);
                
        });
        }
        
       }, [])
       const [dataForm, setDataForm] = useState('');
       const [step, setStep] = useState(1);
       const [valid, SetIsValid] = useState({
           isValidPhoneNumber: false,
         });
        const [open, setOpen] = useState (false)
       const [message, setMessage] = useState('')
       const [typefille, setTypeFile] = useState(false)
       const[ messageAlerte, setMessageAlerte] = useState('')
       const [depotsuccess, setDeppotSuccess] = useState(false);
       const [depotsuccess2, setDeppotSuccess2] = useState(false);
       const maxFileSize = 1024 * 1024 * 2; //1Mo
       const [show, setShow] = useState(false);
       const [complete, setComplete] = useState(false);
       const handleClose = () => setShow(false);
       const [selectedFiles, setSelectedFiles] = useState({
           "cv":true,
           "copie_carte_id" : true,
           "demande" : true,
           "motivation" : true,
           "copie_diplome" : true,
           "diplome_bac" : true,
           "bulletin1" : true,
           "bulletin2" : true,
           "bulletin3" : true,
       });
       const [gestionfichier, setGestionFichier] = useState({
           "cv":false,
           "copie_carte_id" : false,
           "demande" : false,
           "motivation" : false,
           "copie_diplome" : false,
           "diplome_bac" : false,
           "bulletin1" : false,
           "bulletin2" : false,
           "bulletin3" : false,
       });
       const [submitted, setSubmitted] = useState(false);
       const [data, setData] = useState();  /*données d'un user avec dépot réussie */
       const handleFileChange = (event, key) => {
           var file = event.target.files[0];
           console.log(file)
               const elements = document.getElementsByName(key)
               if (file?.type === "application/pdf") {
                if (file?.size < maxFileSize ){
                        setTypeFile(false)
                        setSelectedFiles((prevSelectedFiles) => ({
                            ...prevSelectedFiles,
                            [key]: file
                        }));
                        setGestionFichier((prevSelectedFiles) => ({
                            ...prevSelectedFiles,
                            [key]: true
                        }));
                        for (var i = 0; i < elements.length; i++) {
                            var element1 = elements[i];
                            element1.style.border = "";
                        }
                } else {
                        setGestionFichier((prevSelectedFiles) => ({
                            ...prevSelectedFiles,
                            [key]: false
                        }));
                        setSelectedFiles((prevSelectedFiles) => ({
                            ...prevSelectedFiles,
                            [key]: false
                        }));
                        for (var j = 0; j < elements.length; j++) {
                            var element2 = elements[j];
                            element2.style.border = "2px solid #BC0C0C";
                            element2.style.transition ='border 0.5s ease-in-out;'
                        }
                }
               } else {
                setOpen(true)
                setMessage("format de fichier non permis")
                    console.log('type incorrect')
                    setSelectedFiles((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: false
                    }));
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: false
                    }));
                    return ;
               }
       };
const departement = [
//   {
//     libelle: "Departement Geoscience Appliqué et Environnement",
//     code: "DGAE"
//   },
    {
    libelle: "Departement Gestion des Organisations",
    code: "DGO"
    }
];
       const cycle = ["Licence"] ;
       const filieres = {
        "DGAE" : {
            "ENV" : "Environnement",
            "GOE" : "Géomatique",
            "HA" : "Hydraulique-Assainissement"
        },
        "DGO" : {
            "FINANCE COMPTABILITE" : "Master en Sciences de Gestion - Option Finance-Comptabilité",
            "MANAGEMENT DES ORGANISATIONS" : "Master en Sciences de Gestion - Option Management des Organisations",
            "ÉCONOMIE INDUSTRIELLE ET DE L'INNOVATION" : "Master en Économie Industrielle et de l'Innovation"
        }
       }
       function handleChange (e) {
           const name= e.target.name;
           let value = e.target.value;
           // console.log(value,name)
           if (name === 'telephone' ) {
               const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
               SetIsValid((valid) => ({
                   ...valid,
                   isValidPhoneNumber: phoneRegex.test(value),
               }));
           }
           setDataForm({ ...dataForm, [name]: value });
           // console.log(value,name)
       }
       const handleSubmit = async (e) => {
           try {
               e.preventDefault();
               const formData = new FormData();
               formData.append('email', creds.email)
               formData.append('ecole_postulee', 'POLYTECH')
               const nameFiles = ["cv","copie_carte_id","demande","motivation","copie_diplome","diplome_bac","bulletin1","bulletin2","bulletin3"]
               for (const i in nameFiles) {
                   if (selectedFiles[nameFiles[i]]) {
                       if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                           formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                       } else {
                           // console.log("fichier trop gros");
                       }
                   }
               }
                // data.prenom = dataForm.prenom.trim() ;
                // data.nom = dataForm.nom.trim() ;
               for (let key in dataForm) {
                   // console.log(dataForm[key])
                   if (dataForm.hasOwnProperty(key)) {
                         if( dataForm[key] !== null) {
                           formData.append(key ,dataForm[key])
                         }
                 }
               }
               var showALerte = nameFiles.some(field => selectedFiles[field] === false);
            for (let pair of formData.entries()) {
                   console.log(pair[0] + ':' + pair[1]);
                 }
               if (!valid.isValidPhoneNumber) {
                   setMessageAlerte('Incorrect')
                   setShow(true);
               
               }
               else if (showALerte) {
                    setShow(true);
                   //  setOk(false)
               }
               else if (typefille) {
                   alert('format de fichier incoorecte !')
               }
               else {
                   setComplete(true)
                   setSubmitted(true);
                   const response = await axios.post(
                       `${Env().API_URL}/admission/`,
                       formData,
               {
                       headers: {
                       'Content-Type': 'multipart/form-data',
                       },
                       });
               if (response.status === 200) {
                   if (response.data.detail) {
                       setSubmitted(false);
                       setDeppotSuccess2(true)
                   } else {
                       setSubmitted(false);
                       const dataPersonDepot = response?.data?.data;
                       setData(dataPersonDepot);
                       setDeppotSuccess(true);
                   }
               } else {
                   console.error('Error uploading files');
                   console.log("Détail de la réponse ",response.status)
               }
           }
       } catch (error) {
           setSubmitted(false);
          console.error('Error', error);
       }
   };
       
  return (
    <div className='container mb-2 ' id='mainDepot'>
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        <Alert show={show} handleClose={handleClose} />
        {/* {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }  */}
        {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
        <div id='nameModule' className=''>
                    <p> {step===1 ? 'Informations personnelles' : 'Informations Complémentaires' }</p>
        </div>
        <Form onSubmit={handleSubmit}>
            <div id="step1" className='mb-3'>
            <Form.Group>
                <div className='d-inline'>
                    <span style={{'font-weight':'  !important'}}>Civilite</span> <br />
                    <Form.Check
                    inline
                            type="radio"
                            label="Monsieur"
                            value='Monsieur'
                            required
                            checked = {dataForm.civilite === 'Monsieur'}
                            name="civilite"
                            onChange={handleChange}
                        />
                    </div>
                    <div className='d-inline'>
                        <Form.Check
                            inline
                            type="radio"
                            label="Madame"
                            value='Madame'
                            checked = {dataForm.civilite === 'Madame'}
                            required
                            name="civilite"
                            onChange={handleChange}
                        />
                    </div>
                </Form.Group>
                <div className='row' id='test'>
                <Input placeholder='prenom' className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                <Input placeholder='nom' className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                </div>
                <div className='row'>
                    <Input  className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} />
                    <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Lieu de naissance" name='lieu_naissance' onChange={handleChange} />
                </div> 
                <InputT placeholder='XXXXXXXXX' type='number' value={dataForm.telephone || ''} label="Téléphone"  name='telephone' onChange={handleChange} />
                {!valid.isValidPhoneNumber ? <span style={{color:'red'}}>{messageAlerte} </span>: null}
                <Input placeholder='Dakar' type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
            </div>
            <div id="step2">
            <Form.Group id='serie'>
                    <Form.Label className='fw-medium'>Niveau Formation  <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='cycle' required value={dataForm.cycle} onChange={handleChange}>
                        <option key='' value="" >--- Selectionner ---</option>
                        {/* <option key='Licence' value="Licence">Licence 3</option> */}
                        <option key='Master' value="Master">Master</option>
                    </Form.Select>
                </Form.Group>
             <Form.Group id='serie'>
                    <Form.Label className='fw-medium'>Departement  <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='departement' required value={dataForm.departement} onChange={handleChange}>
                        <option key='' value="" >--- Selectionner ---</option>
                        {departement.map((item) => (
                            <option key={item.code} value={item.code}>{item.libelle}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            <Form.Group id='serie'>
                    <Form.Label className='fw-medium'>Filière  <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='filiere' required value={dataForm.filiere} onChange={handleChange}>
                        <option key='' value="" >--- Selectionner ---</option>
                        {dataForm.departement ? Object.keys(filieres[dataForm.departement]).map((item) => (
                            <option key={item} value={item}>{filieres[dataForm.departement][item]}</option>
                        )) : null}
                    </Form.Select>
                </Form.Group>
            </div>
            <InputF required={true} className="rounded-left mb-2" label="Diplome BAC" message={<span style={{color:'red'}}>*</span>} type='file' name='resume_these' onChange={(e) => handleFileChange(e,"diplome_bac")} />
            {!selectedFiles["diplome_bac"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
            <InputF required={true} id="copie_carte" className="rounded-left mb-2" label="Copie légalisée de la carte nationale d'identité" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
            {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
            <InputF required={true} className="rounded-left mb-2" label="CV" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
            {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
            <InputF required={true} className="rounded-left mb-2" label="Demande adréssée au directeur de POLYTECH" message={<span style={{color:'red'}}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e,"demande")} />
            {!selectedFiles["demande"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
            <InputF required={true} className="rounded-left mb-2" label="Lettre de Motivation" message={<span style={{color:'red'}}>*</span>} type='file' name='motivation' onChange={(e) => handleFileChange(e,"motivation")} />
            {!selectedFiles["motivation"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
            <InputF required={true} className="rounded-left mb-2" label="Copie légalisée du diplome de licence ou équivalent." message={<span style={{color:'red'}}>*</span>} type='file' name='copie_diplome' onChange={(e) => handleFileChange(e,"copie_diplome")} />
            {!selectedFiles["copie_diplome"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
            <InputF required={true} className="rounded-left mb-2" label="Bulletin de la licence 1" message={<span style={{color:'red'}}>*</span>} type='file' name='bulletin1' onChange={(e) => handleFileChange(e,"bulletin1")} />
            {!selectedFiles["bulletin1"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
            <InputF required={true} className="rounded-left mb-2" label="Bulletin de la licence 2" message={<span style={{color:'red'}}>*</span>} type='file' name='bulletin2' onChange={(e) => handleFileChange(e,"bulletin2")} />
            {!selectedFiles["bulletin2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
            {dataForm.cycle ==='Master' ? <>
            <InputF required={true} className="rounded-left mb-2" label="Bulletin de la licence 3" message={<span style={{color:'red'}}>*</span>} type='file' name='bulletin3' onChange={(e) => handleFileChange(e,"bulletin3")} />
            {!selectedFiles["bulletin3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
            </> : null}
            <div>
                <Button variant="primary" type='submit' size="md"
                // disabled={!ok}
                style={{ paddingBottom : '30px', marginBottom : '30px'}}
                    className="p-2 float-end m-3">
                    Envoyer  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            </div>
            
        </Form>
    </div>
  )
}

export default Admission